
<div vbDraggable [dragData]="getDragData(index)" [dragOptions]="dragOptions" [dragEnabled]="isPreview && isProducer && cfg.userId" (dragStop)="onDragStop($event)" *ngIf="stream | async as videoStream; else slotNum">
	<video autoplay [muted]="true" [srcObject]="videoStream"></video>
	<button type="button" *ngIf="isPreview && isProducer" vbBtnSecondary (click)="remove()">
		{{ 'Remove' | translate }}
	</button>
</div>

<ng-template #slotNum>
	<div *ngIf="isPreview" [ngClass]="styles.placeholder">
		{{ label }}
	</div>
</ng-template>
